/*
 * @Date: 2024-07-19 12:53:31
 * @LastEditors: p彭 9878922+p-pengrulin@user.noreply.gitee.com
 * @LastEditTime: 2024-10-17 10:10:13
 */
/* global dataLayer */
import "./global.css";
import Vue, { createApp, onErrorCaptured } from "vue";

// import Web3Plugin from "./web3";
import App from "./App.vue";
import AppMobile from "./AppMobile.vue";
import router from "./router";
import store from "./store";
import OuterLink from "@/components/Worldview_Page/OuterLink.vue";
import LoadingData from "./components/LoadingData.vue";
import { Masonry, MasonryItem } from "masonry-layout";
import i18n from "./i18n";
import { sendToLark } from "@/api/publicApi";
import { serialize, isMobile, setRootSize } from "@/utils/common_method";
import setActivityKey from "@/utils/setActivityKey.js";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
//import { createMetaManager } from 'vue-meta';
import "animate.css";
import slideIn from "./directive/vSlideIn.js";
import SolanaWallets from "solana-wallets-vue";
import {
  PhantomWalletAdapter,
  SolflareWalletAdapter,
} from "@solana/wallet-adapter-wallets";
import "solana-wallets-vue/styles.css";
import "./reset.scss";
import VueTyped from "vue3-typed-js";
import Vue3Lottie from "vue3-lottie";
import { registerMicroApps, start } from "qiankun";

registerMicroApps([
  {
    name: "react-app",
    entry: "https://atlasweb.sinaearts.vip",
    // entry: "https://atlas.beart.one",
    // entry: "https://192.168.137.1:5174/", // React 子应用启动地址
    container: "#react-container",
    activeRule: "/mobile-play", // 激活路由前缀
    props: {
      basename: "/mobile-play", // 传递给子应用的路由基准
    },
  },
]);

start({
  sandbox: { experimentalStyleIsolation: true }, // 启用样式隔离
});
const walletOptions = {
  wallets: [new PhantomWalletAdapter(), new SolflareWalletAdapter()],
  autoConnect: false,
};

setRootSize();
setActivityKey();
window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
gtag("js", new Date());
gtag("config", "G-D8CMKW9MJE");
const app = createApp(App);
app.use(i18n);
app.component("VueMasonry", Masonry);
app.use(ElementPlus);
app.component("VueMasonryItem", MasonryItem);
app.use(store);
app.use(router);
app.use(VueTyped);
app.use(Vue3Lottie);
app.component("outer-link", OuterLink);
app.component("LoadingData", LoadingData);
// app.use(Web3Plugin);
app.use(SolanaWallets, walletOptions);
app.directive("slideIn", slideIn);

// 监听来自 iframe 的消息
window.addEventListener("message", function(event) {

  const message = event.data;

  if (message.action === 'copy') {
    const text = message.text;
    
    // 使用剪贴板 API 将内容复制到剪贴板
    navigator.clipboard.writeText(text).then(() => {
      console.log("内容已复制到剪贴板");
    }).catch(err => {
      console.error("复制失败", err);
    });
  }
});

if (!window.location.href.includes("localhost")) {
  app.config.errorHandler = function (err, instance, info) {
    let errorData = {
      name: "捕获js异常",
      errObj: err.toString(),
      date: new Date(),
      path: window.location.href,
      info: info,
    };
    sendToLark({
      text: serialize(errorData),
    }).catch(() => {});
  };
}

app.mount("#app");
//app.use(createMetaManager());
